import { memo } from 'react';

const CompactNavigationSidebar = () => {
  return <div>CompactNavigationSidebar</div>;
};

export default memo(CompactNavigationSidebar);
